import styled from "styled-components";

export const FootprintSearchForm = styled.form`
  display: flex;
  gap: 1rem;
`;
